export enum AdminProcessingApiTag {
  Counters = 'ProcessingCounters',
}

export const adminProcessingApiTags = Object.values(AdminProcessingApiTag);
